import React, { useEffect, useRef, useState } from 'react';
const { registerPaymentMethod } = window.wc.wcBlocksRegistry;
const data = wc.wcSettings.getSetting('cartadicreditopay_block_data');

const CartadicreditopayIframeContent = (props) => {
    const containerRef = useRef(null);
    const { eventRegistration, emitResponse } = props;
    const { onPaymentSetup } = eventRegistration;

    async function getCardToken() {
        try {
            const validateResult = await Cartadicreditopay.getValidateResult();
            if (validateResult) {
                try {
                    let { token } = await Cartadicreditopay.confirmPay();
                    return token;
                } catch (confirmError) {
                    console.error('Payment confirmation failed:', confirmError);
                }
            }
        } catch (validateError) {
            console.error('Validation failed:', validateError);
        }
    }

    useEffect(() => {
        if (containerRef.current) {
            getIframeToken()
        }
    }, []);

    //从后端实时获取iframeToken
    async function getIframeToken(){
        await fetch(cartadicreditopay_params.ajax_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({ action: 'get_cartadicreditopay_iframe_token' }),
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success && containerRef.current) {
                    initIframe(data.data.iframeToken)
                }
            });
    }

    //渲染iframe支付框
    function initIframe(iframeToken){
        var elements = Cartadicreditopay.elements();
        var card = elements.create("card", {
            token: iframeToken, //通过开放接口API获取
            style: {
                base: {
                    backgroundColor: "#fff",
                    color: "#000",
                    fontSize: "14px",
                    floatLabelSize: "12px",
                    floatLabelColor: "#333333",
                    floatLabelWeight: "400",
                },
            },
            isAllowScale: false, //是否允许缩放  通过设置meta name="viewport" 的content initial-scale=1.0, minimum-scale=1.0, maximum-scale=2.0, user-scalable=no, width=device-width
            language: "default",
        });
        card.mount("#alpay-card-element").catch((err) => {
            console.error(err);
        });
    }

    //提交时将参数组合提交
    useEffect( () => {
        const unsubscribe = onPaymentSetup( async () => {

            const cardToken = await getCardToken();
            const cartadicreditopay_sid_card = cartaDiCreditoPayShield.getSessionId();

            if ( cardToken ) {
                return {
                    type: emitResponse.responseTypes.SUCCESS,
                    meta: {
                        paymentMethodData: {
                            'cartadicreditopay_token' : cardToken,
                            'cartadicreditopay_sid_card' : cartadicreditopay_sid_card,
                            'cartadicreditopay_method_card' : 'card',
                        },
                    },
                };
            }

            return {
                type: emitResponse.responseTypes.ERROR,
                message: 'Please check your card information',
            };
        } );
        // Unsubscribes when this component is unmounted.
        return () => {
            unsubscribe();
        };
    }, [] );

    return (
        <>
            <div ref={containerRef} id="alpay-card-element"></div>
        </>
    );
};




const CartadicreditopayLocalContent = (props)=>{
    const { eventRegistration, emitResponse } = props;
    const { onPaymentSetup } = eventRegistration;
    const [selected, setSelected] = useState(null);

    const handleSelect = (methodId) => {
        setSelected(methodId);
    };

    //提交时将参数组合提交
    useEffect( () => {
        const unsubscribe = onPaymentSetup( async () => {

            const cartadicreditopay_sid_local = cartaDiCreditoPayShield.getSessionId();

            if(selected){
                return {
                    type: emitResponse.responseTypes.SUCCESS,
                    meta: {
                        paymentMethodData: {
                            'cartadicreditopay_method_local' : selected,
                            'cartadicreditopay_sid_local' : cartadicreditopay_sid_local,
                        },
                    },
                };
            }
            return {
                type: emitResponse.responseTypes.ERROR,
                message: 'Please check your card information',
            };
        } );
        // Unsubscribes when this component is unmounted.
        return () => {
            unsubscribe();
        };
    }, [selected] );

    return (
        <div style={styles.container}>
            <div style={styles.grid}>
                {data.local.local_gateways.map((method) => (
                    <div
                        key={method.key}
                        onClick={() => handleSelect(method.key)}
                        style={{
                            ...styles.option,
                            borderColor:
                                selected === method.key ? '#007cba' : 'rgba(0,0,0,0.1)',
                            boxShadow:
                                selected === method.key
                                    ? '0 0 6px rgba(0,124,186,0.4)'
                                    : 'none',
                        }}
                    >
                        <img src={method.logo_url} alt={method.name} style={styles.icon} />
                        <span style={styles.label}>{method.name}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}

const styles = {
    container: {
        padding: '16px',
        borderRadius: '12px',
        border: '1px solid #e0e0e0',
        backgroundColor: '#fff',
    },
    title: {
        fontSize: '16px',
        marginBottom: '12px',
        color: '#333',
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
        gap: '12px',
    },
    option: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '10px 12px',
        border: '2px solid transparent',
        borderRadius: '10px',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        backgroundColor: '#fafafa',
    },
    icon: {
        width: '40%',
        height: '100%',
    },
    label: {
        fontSize: '14px',
        color: '#333',
    },
};


const PaymentMethodPreview = () => {
    return (
        <div style={{ padding: '10px', border: '1px dashed gray' }}>
            <strong>Credit\Debit Card（Preview）</strong>
        </div>
    );
};

const LocalPaymentMethodPreview = () => {
    return (
        <div style={{ padding: '10px', border: '1px dashed gray' }}>
            <strong>Local Gateways（Preview）</strong>
        </div>
    );
};


if(data.card){
    registerPaymentMethod({
        name: 'cartadicreditopay_cc',
        label: data.card.title,
        ariaLabel: data.card.title,
        content: <CartadicreditopayIframeContent/>,
        edit: <PaymentMethodPreview/>,
        canMakePayment: () => true,
        supports: {
            features: ['products'],
        },
    });
}

if(data.local){
    registerPaymentMethod({
        name: 'cartadicreditopay_local',
        label: data.local.title,
        ariaLabel: data.local.title,
        content: <CartadicreditopayLocalContent/>,
        edit: <LocalPaymentMethodPreview/>,
        canMakePayment: () => true,
        supports: {
            features: ['products'],
        },
    });
}




